import { IconButton, mergeStyles, Modal, PrimaryButton, Stack, useTheme } from '@fluentui/react';
import React, { useEffect } from 'react';
import { BaseComponentProps, Input, RemoteMessage } from '..';
import Validator from 'validator';
import { emailConsent } from '../../apps/ZoryveDirect/ZoryveDirect.components';

export const InputEmailModal = (props: BaseComponentProps): JSX.Element => {
  const { onSubmit } = props;
  const theme = useTheme();
  const [isModalOpen, setIsModalOpen] = React.useState(true);
  const [emailTermsChecked, setEmailTermsChecked] = React.useState(false);
  const [email, setEmail] = React.useState('');
  const [submitDisabled, setSubmitDisabled] = React.useState(true);
  const width = Math.min(window.innerWidth, window.outerWidth) - 64;

  useEffect(() => {
    // Diasble body scroll when Modal open
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      // Enable body scroll when Modal unmounts
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen]);

  useEffect(() => {
    setSubmitDisabled(!emailTermsChecked || !Validator.isEmail(email));
  }, [emailTermsChecked, email]);

  const handleOnSubmit = (input: Input) => {
    setIsModalOpen(false);
    onSubmit && onSubmit([input]);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.name === 'emailTerms') {
      setEmailTermsChecked(!emailTermsChecked);
    } else {
      setEmail(event.target.value);
    }
  };

  if (!isModalOpen) {
    return (
      <RemoteMessage
        text={
          <a
            style={{
              cursor: 'pointer',
              color: theme.palette.black,
              textDecoration: 'underline',
            }}
            onClick={() => setIsModalOpen(true)}
          >
            EMAIL ME
          </a>
        }
      ></RemoteMessage>
    );
  }

  return (
    <Modal
      isOpen={isModalOpen}
      styles={{
        main: {
          borderRadius: theme.effects.roundedCorner6,
          overflowY: 'scroll',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
      allowTouchBodyScroll={true}
    >
      <div
        className={mergeStyles({
          padding: '1rem',
          boxShadow: theme.effects.elevation8,
          width: width,
          borderRadius: `${theme.effects.roundedCorner6} ${theme.effects.roundedCorner6} 0 0`,
          background: theme.palette.neutralPrimary,
        })}
      >
        <Stack
          style={{
            height: '100%',
            color: 'black',
            paddingBottom: '0rem',
            overflowY: 'scroll',
          }}
        >
          <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
            <h3
              style={{
                color: 'black',
                fontSize: '14px',
                margin: 0,
                paddingBottom: '0rem',
              }}
            >
              EMAIL MY SAVINGS CARD TO ME AND SIGN UP FOR ADDITIONAL UPDATES
            </h3>

            <IconButton
              style={{
                color: theme.palette.neutralLight,
                fontSize: '6px',
                position: 'sticky',
                float: 'right',
                top: 0,
              }}
              iconProps={{ iconName: 'Cancel' }}
              ariaLabel="Close popup modal"
              onClick={() => setIsModalOpen(false)}
            />
          </Stack>
          <div
            style={{
              maxHeight: window.innerHeight / 1.5,
              overflow: 'auto',
              paddingTop: '0.5rem',
              paddingBottom: '1rem',
              fontSize: '11px',
              fontWeight: 400,
            }}
          >
            {emailConsent}
            <Stack
              horizontal
              horizontalAlign="start"
              style={{ paddingTop: '0.8rem', paddingBottom: '1rem' }}
            >
              <input
                type="checkbox"
                id="emailTerms"
                name="emailTerms"
                checked={emailTermsChecked}
                onChange={handleChange}
                style={{
                  width: '1.5rem',
                  height: '1.5rem',
                  borderRadius: theme.effects.roundedCorner6,
                }}
              />
              <Stack horizontalAlign="start" verticalAlign="center">
                <label htmlFor="emailTerms" style={{ marginLeft: '0.5rem', fontSize: '12px' }}>
                  I agree
                </label>
              </Stack>
            </Stack>
            <Stack horizontal horizontalAlign="start">
              <input
                type="email"
                id="1"
                name="email"
                key="EMAIL"
                value={email}
                placeholder="Email Address"
                onChange={handleChange}
                style={{
                  width: '100%',
                  height: '1.5rem',
                  borderRadius: '10px',
                  border: '1px solid',
                  borderColor: '#545C64',
                  padding: '0.5rem',
                  fontSize: '16px',
                }}
              />
            </Stack>
          </div>
        </Stack>

        <Stack horizontal horizontalAlign="center" style={{ padding: '1rem' }}>
          <PrimaryButton
            className={mergeStyles({
              height: '2.5rem',
              minWidth: '8rem',
              borderRadius: theme.effects.roundedCorner6,
              boxShadow: theme.effects.elevation8,
              fontSize: '16px',
              color: theme.palette.neutralLight,
              background: theme.palette.themePrimary,
              ':disabled': {
                background: '#faecc0',
                color: '#c0bdb5',
              },
            })}
            disabled={submitDisabled}
            onClick={() =>
              handleOnSubmit({
                id: '1',
                name: 'email',
                key: 'EMAIL',
                value: email,
              })
            }
          >
            Submit
          </PrimaryButton>
        </Stack>
      </div>
    </Modal>
  );
};
